import {
    FiltersModel,
    SearchModel,
    SortOption,
    SortSettings,
    SearchRequest
} from '@features/search/interfaces';
import {Proposal} from '@services/user-gw';
import {BasketItemModel} from '@features/basket/interfaces';
import {PriceLevelSettings} from 'app/priceLevelSettings';
import {getFilteredAndSorted} from './getFilteredAndSorted';
import {processSearchApiResults} from './processSearchApiResults';

function countAllProposals(model: SearchModel): number {
    return [...model.searched, ...model.original, ...model.analogs].reduce(
        (sum, item) => sum + item.proposals.length,
        0
    );
}

export function countAdditionalGen2Offers({
    existingApiResults,
    gen2ApiResults,
    currentSourceResults,
    searchRequest,
    basketMap,
    settings,
    filters,
    sortOptions,
    sortSettings
}: {
    existingApiResults: Proposal[];
    gen2ApiResults: Proposal[];
    currentSourceResults: SearchModel;
    searchRequest: SearchRequest;
    basketMap: Map<string | undefined, BasketItemModel>;
    settings: PriceLevelSettings;
    filters: FiltersModel;
    sortOptions: SortOption[];
    sortSettings: SortSettings;
}): number {
    if (gen2ApiResults.length === 0) {
        return 0;
    }

    const [mergedResults] = processSearchApiResults({
        searchResults: [existingApiResults, [], gen2ApiResults],
        searchRequest,
        basketMap,
        settings
    });

    const mergedFiltered = getFilteredAndSorted(mergedResults, filters, sortOptions, sortSettings);
    const currentFiltered = getFilteredAndSorted(
        currentSourceResults,
        filters,
        sortOptions,
        sortSettings
    );

    return Math.max(0, countAllProposals(mergedFiltered) - countAllProposals(currentFiltered));
}
